
import type { LocalityTypeKey } from "./LocalityType.ts";

// Generated from io.spcfy.orders.samplemeta.enums.HabitatType

export type HabitatTypeKey =
  "DISCONTINUOUS_URBAN_FABRIC" |
  "CONTINUOUS_URBAN_FABRIC" |
  "INDUSTRIAL_OR_COMMERCIAL_UNITS" |
  "CONSTRUCTION_SITES" |
  "DUMP_SITES" |
  "GREEN_URBAN_AREAS" |
  "SPORT_AND_LEISURE_FACILITIES" |
  "AIRPORTS" |
  "ROAD_AND_RAIL_NETWORKS_AND_ASSOCIATED_LAND" |
  "PORT_AREAS" |
  "URBAN_PARKS" |
  "FRUIT_TREES_AND_BERRY_PLANTATIONS" |
  "OLIVE_GROVES" |
  "PASTURES" |
  "COMPLEX_CULTIVATION_PATTERNS" |
  "AGRO_FORESTRY_AREAS" |
  "ANNUAL_CROPS_ASSOCIATED_WITH_PERMANENT_CROPS" |
  "LAND_PRINCIPALLY_OCCUPIED_BY_AGRICULTURE_WITH_SIGNIFICANT_AREAS_OF_NATURAL_VEGETATION" |
  "BROAD_LEAVED_FOREST" |
  "CONIFEROUS_FOREST" |
  "MIXED_FOREST" |
  "TRANSITIONAL_WOODLAND_SHRUB" |
  "SCLEROPHYLLOUS_VEGETATION" |
  "BURNT_AREAS" |
  "NON_IRRIGATED_ARABLE_LAND" |
  "PERMANENTLY_IRRIGATED_LAND" |
  "RICE_FIELDS" |
  "VINEYARDS" |
  "INLAND_MARSHES" |
  "PEAT_BOGS" |
  "SALT_MARSHES" |
  "COASTAL_LAGOONS" |
  "SALINES" |
  "SEA_AND_OCEAN" |
  "ESTUARIES" |
  "INTERTIDAL_FLATS" |
  "BEACHES_DUNES_SANDS" |
  "NATURAL_GRASSLANDS" |
  "MOORS_AND_HEATHLAND" |
  "SPARSELY_VEGETATED_AREAS" |
  "MANAGED_GRASSLANDS" |
  "BARE_ROCKS" |
  "GLACIERS_AND_PERPETUAL_SNOW" |
  "WATER_COURSES" |
  "WATER_BODIES";


export interface HabitatTypeDTO {
  key: HabitatTypeKey;
  label: string;
  locality: LocalityTypeKey;    
}


export const HabitatTypes: Record<HabitatTypeKey, HabitatTypeDTO> = {
  DISCONTINUOUS_URBAN_FABRIC: { key: "DISCONTINUOUS_URBAN_FABRIC", label: "Discontinuous urban fabric", locality: "URBAN" },
  CONTINUOUS_URBAN_FABRIC: { key: "CONTINUOUS_URBAN_FABRIC", label: "Continuous urban fabric", locality: "URBAN" },
  INDUSTRIAL_OR_COMMERCIAL_UNITS: { key: "INDUSTRIAL_OR_COMMERCIAL_UNITS", label: "Industrial or commercial units", locality: "URBAN" },
  CONSTRUCTION_SITES: { key: "CONSTRUCTION_SITES", label: "Construction sites", locality: "URBAN" },
  DUMP_SITES: { key: "DUMP_SITES", label: "Dump sites", locality: "URBAN" },
  GREEN_URBAN_AREAS: { key: "GREEN_URBAN_AREAS", label: "Green urban areas", locality: "URBAN" },
  SPORT_AND_LEISURE_FACILITIES: { key: "SPORT_AND_LEISURE_FACILITIES", label: "Sport and leisure facilities", locality: "URBAN" },
  AIRPORTS: { key: "AIRPORTS", label: "Airports", locality: "URBAN" },
  ROAD_AND_RAIL_NETWORKS_AND_ASSOCIATED_LAND: { key: "ROAD_AND_RAIL_NETWORKS_AND_ASSOCIATED_LAND", label: "Road and rail networks and associated land", locality: "URBAN" },
  PORT_AREAS: { key: "PORT_AREAS", label: "Port areas", locality: "URBAN" },
  URBAN_PARKS: { key: "URBAN_PARKS", label: "Urban parks", locality: "URBAN" },
  FRUIT_TREES_AND_BERRY_PLANTATIONS: { key: "FRUIT_TREES_AND_BERRY_PLANTATIONS", label: "Fruit trees and berry plantations", locality: "SEMI_AGRICULTURAL" },
  OLIVE_GROVES: { key: "OLIVE_GROVES", label: "Olive groves", locality: "SEMI_AGRICULTURAL" },
  PASTURES: { key: "PASTURES", label: "Pastures", locality: "SEMI_AGRICULTURAL" },
  COMPLEX_CULTIVATION_PATTERNS: { key: "COMPLEX_CULTIVATION_PATTERNS", label: "Complex cultivation patterns", locality: "SEMI_AGRICULTURAL" },
  AGRO_FORESTRY_AREAS: { key: "AGRO_FORESTRY_AREAS", label: "Agro-forestry areas", locality: "SEMI_AGRICULTURAL" },
  ANNUAL_CROPS_ASSOCIATED_WITH_PERMANENT_CROPS: { key: "ANNUAL_CROPS_ASSOCIATED_WITH_PERMANENT_CROPS", label: "Annual crops associated with permanent crops", locality: "SEMI_AGRICULTURAL" },
  LAND_PRINCIPALLY_OCCUPIED_BY_AGRICULTURE_WITH_SIGNIFICANT_AREAS_OF_NATURAL_VEGETATION: { key: "LAND_PRINCIPALLY_OCCUPIED_BY_AGRICULTURE_WITH_SIGNIFICANT_AREAS_OF_NATURAL_VEGETATION", label: "Land principally occupied by agriculture with significant areas of natural vegetation", locality: "SEMI_AGRICULTURAL" },
  BROAD_LEAVED_FOREST: { key: "BROAD_LEAVED_FOREST", label: "Broad-leaved forest", locality: "FOREST" },
  CONIFEROUS_FOREST: { key: "CONIFEROUS_FOREST", label: "Coniferous forest", locality: "FOREST" },
  MIXED_FOREST: { key: "MIXED_FOREST", label: "Mixed forest", locality: "FOREST" },
  TRANSITIONAL_WOODLAND_SHRUB: { key: "TRANSITIONAL_WOODLAND_SHRUB", label: "Transitional woodland-shrub", locality: "FOREST" },
  SCLEROPHYLLOUS_VEGETATION: { key: "SCLEROPHYLLOUS_VEGETATION", label: "Sclerophyllous vegetation", locality: "FOREST" },
  BURNT_AREAS: { key: "BURNT_AREAS", label: "Burnt areas", locality: "FOREST" },
  NON_IRRIGATED_ARABLE_LAND: { key: "NON_IRRIGATED_ARABLE_LAND", label: "Non-irrigated arable land", locality: "AGRICULTURE" },
  PERMANENTLY_IRRIGATED_LAND: { key: "PERMANENTLY_IRRIGATED_LAND", label: "Permanently irrigated land", locality: "AGRICULTURE" },
  RICE_FIELDS: { key: "RICE_FIELDS", label: "Rice fields", locality: "AGRICULTURE" },
  VINEYARDS: { key: "VINEYARDS", label: "Vineyards", locality: "AGRICULTURE" },
  INLAND_MARSHES: { key: "INLAND_MARSHES", label: "Inland marshes", locality: "WETLANDS" },
  PEAT_BOGS: { key: "PEAT_BOGS", label: "Peat bogs", locality: "WETLANDS" },
  SALT_MARSHES: { key: "SALT_MARSHES", label: "Salt marshes", locality: "WETLANDS" },
  COASTAL_LAGOONS: { key: "COASTAL_LAGOONS", label: "Coastal lagoons", locality: "WETLANDS" },
  SALINES: { key: "SALINES", label: "Salines", locality: "WETLANDS" },
  SEA_AND_OCEAN: { key: "SEA_AND_OCEAN", label: "Sea and ocean", locality: "COASTAL_MARINE" },
  ESTUARIES: { key: "ESTUARIES", label: "Estuaries", locality: "COASTAL_MARINE" },
  INTERTIDAL_FLATS: { key: "INTERTIDAL_FLATS", label: "Intertidal flats", locality: "COASTAL_MARINE" },
  BEACHES_DUNES_SANDS: { key: "BEACHES_DUNES_SANDS", label: "Beaches, dunes, sands", locality: "COASTAL_MARINE" },
  NATURAL_GRASSLANDS: { key: "NATURAL_GRASSLANDS", label: "Natural grasslands", locality: "GRASSLANDS" },
  MOORS_AND_HEATHLAND: { key: "MOORS_AND_HEATHLAND", label: "Moors and heathland", locality: "GRASSLANDS" },
  SPARSELY_VEGETATED_AREAS: { key: "SPARSELY_VEGETATED_AREAS", label: "Sparsely vegetated areas", locality: "GRASSLANDS" },
  MANAGED_GRASSLANDS: { key: "MANAGED_GRASSLANDS", label: "Managed Grasslands", locality: "GRASSLANDS" },
  BARE_ROCKS: { key: "BARE_ROCKS", label: "Bare rocks", locality: "MOUNTAINOUS" },
  GLACIERS_AND_PERPETUAL_SNOW: { key: "GLACIERS_AND_PERPETUAL_SNOW", label: "Glaciers and perpetual snow", locality: "MOUNTAINOUS" },
  WATER_COURSES: { key: "WATER_COURSES", label: "Water courses", locality: "FRESHWATER" },
  WATER_BODIES: { key: "WATER_BODIES", label: "Water bodies", locality: "FRESHWATER" }
};
